// Core
import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Tooltip, Form, Input, InputNumber, Select,notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

// App
import { Modal } from '../../../components/modals/antd-modals';
import { RecordViewWrapper } from './Style';
import { Main, TableWrapper, BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { PageHeader } from '../../../components/page-headers/page-headers';
import {
  productoListAction, movimientoCreateAction
} from '../../../redux/administracion/productos/actionCreator';
import { sucursalListAction } from '../../../redux/administracion/sucursales/actionCreator'


const ProductoViewPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registros = useSelector(state => state.ProductoReducer.data);
  const catalogoSucursales = useSelector(state => state.SucursalReducer.dataSelectBox);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [cantidadLabel, setCantidadLabel] = useState('');
  const [precioLabel, setPrecioLabel] = useState('');
  const [showSucursal, setShowSucursal] = useState(false);

  useEffect(() => {
    if (productoListAction) {
      dispatch(productoListAction());
    }
    dispatch(sucursalListAction());
  }, [dispatch]);

  const dataSource = [];

  const onHandleSearch = e => {
    dispatch(productoListAction(e.target.value));
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleOk = async values => {
    console.log("movimiento: ", values)
    const responseApi = await dispatch(movimientoCreateAction(values));
    if (responseApi) {
      let mensaje = 'Movimiento creado exitosamente';    
      notification.success({
        message: mensaje,
      });
      form.resetFields();
      dispatch(productoListAction());
      
    } else {
      notification.error({
        message: 'Error al gestionar movimientos',
      });
    }
    setModalVisible(false);        
  };

  
  const showModal = (idProducto, nombre, tipo) => {
    form.setFieldsValue({
      idTipoMovimiento: tipo,
      idProducto: idProducto
    })
    if (tipo === '1') {
      setModalTitle('ENTRADA DE MERCANCÍA: ' + nombre);
      setCantidadLabel('¿Cuantas piezas estan ingresando?');
      setPrecioLabel('Precio de compra');
      setShowSucursal(false);
    } else {
      setShowSucursal(true);
      setModalTitle('SALIDA DE MERCANCÍA: ' + nombre);
      setCantidadLabel('¿Cuantas piezas estan saliendo?');
      setPrecioLabel('Precio de venta');
    }

    setModalVisible(true);
  }

  if (registros.length)
    registros.map((record, key) => {
      const { id, nombre, descripcion, precio_compra, precio_venta, existencias } = record;
      return dataSource.push({
        key: key + 1,
        nombre,
        descripcion,
        precio_compra: (<span>${precio_compra}</span>),
        precio_venta: (<span>${precio_venta}</span>),
        existencias: (<span>{existencias}</span>),
        action: (
          <div className="table-actions">
            <Tooltip title="Editar información" color="#f8f9ac">
              <Link to={`/admin/productos/editar/${id}`}>
                <Button>
                  <FeatherIcon icon="edit" />
                </Button>
              </Link>
            </Tooltip>
            <Tooltip title="Registrar entrada" color='#f8f9ac'>
              <Button onClick={() => showModal(id, nombre, '1')}>
                <FeatherIcon icon="arrow-down-circle" />
              </Button>
            </Tooltip>
            <Tooltip title="Registrar salida" color='#f8f9ac'>
              <Button onClick={() => showModal(id, nombre, '2')}>
                <FeatherIcon icon="arrow-up-circle" />
              </Button>
            </Tooltip>
            <Tooltip title="Historial de movimientos" color='#f8f9ac'>
              <Button onClick={() => alert('En construcción')}>
                <FeatherIcon icon="file-text" />
              </Button>
            </Tooltip>
          </div>
        ),
      });
    });

  const columns = [
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Último precio compra',
      dataIndex: 'precio_compra',
      key: 'precio_compra',
    },
    {
      title: 'Último precio venta',
      dataIndex: 'precio_venta',
      key: 'precio_venta',
    },
    {
      title: 'Existencias',
      dataIndex: 'existencias',
      key: 'existencias',
    },
    {
      title: 'Acciones',
      dataIndex: 'action',
      key: 'action',
      width: '90px',
    },
  ];

  return (
    <RecordViewWrapper>
      <PageHeader
        subTitle={
          <div>
            <Button className="btn-add_new" size="default" key="1" type="primary">
              <Link to="/admin/productos/agregar">
                <FeatherIcon icon="plus" size={14} /> <span>Agregar nuevo producto</span>
              </Link>
            </Button>
          </div>
        }
        buttons={[
          <div key={1} className="search-box">
            <span className="search-icon">
              <FeatherIcon icon="search" size={14} />
            </span>
            <input onChange={onHandleSearch} type="text" name="recored-search" placeholder="Buscar..." />
          </div>,
        ]}
        ghost        
        title="PRODUCTOS 'DENTAL STORE'"
      />
      <Main>
        <Row gutter={15}>
          <Col className="w-100" md={24}>
            <Cards headless>
              {isLoading ? (
                <div className="spin">
                  <Spin />
                </div>
              ) : (
                <div>
                  <TableWrapper className="table-data-view table-responsive">
                    <Table
                      pagination={{ pageSize: 40, showSizeChanger: true }}
                      dataSource={dataSource}
                      columns={columns}
                      locale={{ emptyText: 'Sin registros' }}
                    />
                  </TableWrapper>
                </div>
              )}
            </Cards>
          </Col>
        </Row>
      </Main>
      <Modal width={800} type="primary" title={modalTitle} visible={modalVisible} footer={null} onCancel={handleCancel}>
        <div className="project-modal">
          <h5 style={{ textTransform: 'uppercase' }}>{modalTitle}</h5> <br />
          <BasicFormWrapper>
            <Form form={form} name="movimientoMercancia" onFinish={handleOk}>
              <Form.Item
                rules={[{ required: true, message: 'Campo obligatorio' }]}
                name="cantidad"
                label={cantidadLabel}
              >
                <Input />
              </Form.Item>
              <Form.Item
                rules={[{ required: true, message: 'Campo obligatorio' }]}
                name="precio"
                label={precioLabel}
              >
                <InputNumber step={0.1} />
              </Form.Item>
              {
                showSucursal ?
                  <Form.Item name="idSucursal" label="Sucursal destino">
                    <Select placeholder="Selecciona..." options={catalogoSucursales} notFoundContent={'Sin registros'} />
                  </Form.Item>
                  : <></>
              }

              <Form.Item
                name="idTipoMovimiento" hidden>
                <Input />
              </Form.Item>

              <Form.Item
                name="idProducto" hidden>
                <Input />
              </Form.Item>

              <Button htmlType="submit" size="default" type="primary" key="submit">
                Guardar
              </Button>
            </Form>
          </BasicFormWrapper>
        </div>
      </Modal>
    </RecordViewWrapper>
  );
};

export default ProductoViewPage;
